export default __webpack_public_path__ + "static/media/onboardingAsideBgMb.058e3df4.png";